import React, { useEffect } from 'react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import FooterWrapper from '../components/FooterWrapper';
import ContactForm from '../components/ContactForm';
import chartColumnDecreasing from '../assets/contact/chart-column-decreasing.svg';
import clockArrowDown from '../assets/contact/clock-arrow-down.svg';
import rocket from '../assets/contact/rocket.svg';
import history from '../assets/contact/history.svg';
import mail from '../assets/contact/mail.svg';
import mailDark from '../assets/contact/mail_dark.svg';

// Sample data for the cards
const cards = [
  { 
    id: 1, 
    description: [
      { text: '80% weniger Routinearbeit ', highlight: true },
      { text: 'dank KI Automatisierung', highlight: false },
    ],
    logo: {
      src: chartColumnDecreasing,
      alt: 'Logo 1',
      width: 100,
      height: 30
    },
    link: '#'
  },
  { 
    id: 2, 
    description: [
      { text: '50% kürzere Projektlaufzeiten ', highlight: true },
      { text: 'durch smarte Workflows', highlight: false },
    ],
    logo: {
      src: clockArrowDown,
      alt: 'Logo 2',
      width: 100,
      height: 30
    },
    link: '#'
  },
  { 
    id: 3, 
    description: [
      { text: '3x schnellere Entscheidungen ', highlight: true },
      { text: 'durch datenbasierte Analysen', highlight: false }
    ],
    logo: {
      src: rocket,
      alt: 'Logo 3',
      width: 100,
      height: 30
    },
    link: '#'
  },
  { 
    id: 4, 
    description: [
      { text: '24/7 Support ', highlight: true },
      { text: 'ohne Ausfälle durch intelligente Systeme', highlight: false }
    ],
    logo: {
      src: history,
      alt: 'Logo 4',
      width: 100,
      height: 30
    },
    link: '#'
  }
];

const ContactMobile = () => {
  useEffect(() => {
    // Add custom styles for the swiper
    const style = document.createElement('style');
    style.textContent = `
      .swiper {
        position: relative;
        padding-bottom: 2.5rem;
        width: 100%;
        overflow: hidden;
        background: transparent !important;
        --swiper-theme-color: transparent !important;
      }

      .swiper-slide {
        width: 278px !important;
        height: 176px !important;
        transition: all 0.3s ease;
        opacity: 0.3;
        position: relative;
        flex-shrink: 0;
      }

      .swiper-slide-active {
        opacity: 1 !important;
      }

      .swiper-slide-next {
        opacity: 1 !important;
      }
      
      .swiper-slide:not(.swiper-slide-active):not(.swiper-slide-next) {
        opacity: 0.3 !important;
      }
      
      .swiper-slide a {
        width: 100%;
        height: 100%;
        display: block;
      }

      .swiper-pagination {
        position: absolute !important;
        bottom: 0 !important;
        left: 0;
        right: 0;
        display: flex !important;
        justify-content: center;
        gap: 8px;
        z-index: 10;
        padding-top: 24px;
      }

      .swiper-pagination-bullet {
        width: 32px;
        height: 2px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 1px;
        opacity: 1;
        transition: all 0.3s ease;
        margin: 0 4px !important;
      }

      .swiper-pagination-bullet-active {
        background: #ffffff;
      }

      .swiper-pagination {
        position: absolute !important;
        bottom: 0 !important;
        left: 0 !important;
        display: flex !important;
        gap: 14px;
        justify-content: flex-start;
        width: auto;
        padding-left: 8px;
      }

      .swiper-pagination-bullet {
        position: relative;
        margin: 0 !important;
        height: 3px !important;
        width: 59px !important;
        border-radius: 2px !important;
        background: rgba(255, 255, 255, 0.1) !important;
        opacity: 1 !important;
        transition: background-color 0.3s;
      }

      .swiper-pagination-bullet:before {
        content: '';
        position: absolute;
        top: -8px;
        right: 0;
        bottom: -8px;
        left: 0;
      }

      .swiper-pagination-bullet:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 0;
        border-radius: 2px;
        background: white;
      }

      .swiper-pagination-bullet-active:after {
        animation: slide-in 5s linear forwards;
      }

      @keyframes slide-in {
        from { width: 0; }
        to { width: 100%; }
      }

      @media (max-width: 767px) {
        .swiper-slide {
          width: 278px !important;
          height: 176px !important;
          margin-right: 20px !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="min-h-screen bg-black-pure flex flex-col">
      <section className="relative z-10 bg-black-pure flex flex-col items-center justify-center py-8 px-4 pt-[100px] overflow-hidden ">
        <div className="w-full max-w-[576px] mx-auto">
          {/* Radial Gradient Blur - Top */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute left-0 top-0 -z-10 size-[466px] translate-x-[-45%] translate-y-[-40%] rounded-full bg-[radial-gradient(50%_50%_at_50%_50%,rgba(100,115,140,.15),transparent)]"
          />
          
          {/* Header Section */}
          <div className="pt-0 mb-8">
            <h1 className="font-sans text-4xl font-medium leading-tight tracking-wide text-white mb-4 text-left" style={{ fontFamily: 'Cal Sans, sans-serif' }}>
              Let's Connect
            </h1>
            <p className="text-base leading-normal text-gray-new-60 text-left mb-6">
              Wir unterstützen dich gerne bei allen Fragen zu KI-Strategien, individuellen Lösungen, Preisen oder speziellen Projektanforderungen.
            </p>
            <div>
              <a 
                href="mailto:hello@blcks.at" 
                className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-5 bg-white text-[#0d0e12] font-medium w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
              >
                <span 
                  className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  aria-hidden="true"
                />
                <img 
                  src={mailDark} 
                  alt="" 
                  className="relative z-10 h-5 w-5 mr-3" 
                  width={18} 
                  height={18}
                />
                <span className="relative z-10 text-[#0d0e12] font-geist font-normal">hello@blcks.at</span>
              </a>
            </div>
          </div>

          {/* Stats Carousel */}
          <div className="w-full bg-transparent relative overflow-hidden mb-8">
            <div className="relative bg-transparent pl-0">
              <Swiper
                modules={[Pagination, Autoplay]}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                wrapperTag="ul"
                slidesPerView="auto"
                spaceBetween={20}
                speed={700}
                pagination={{ clickable: true }}
                loop={false}
                initialSlide={0}
                breakpoints={{
                  768: {
                    centeredSlides: false,
                  },
                }}
              >
                {cards.map((card) => (
                  <SwiperSlide 
                    tag="li" 
                    key={card.id} 
                    style={{ 
                      width: '278px',
                      height: '176px',
                      flexShrink: 0,
                      marginRight: '20px'
                    }}
                  >
                    <a
                      href={card.link}
                      className="group relative block h-[176px] w-[278px] rounded-xl p-5 text-left transition-all duration-200 bg-[#0d0e12]"
                    >
                      <div className="relative z-10 flex h-full flex-col justify-between">
                        <p className="relative text-base leading-normal tracking-tight">
                          {Array.isArray(card.description) ? (
                            card.description.map((part, index) => (
                              <span key={index} className={part.highlight ? 'text-white' : 'text-[#787c87]'}>
                                {part.text}
                              </span>
                            ))
                          ) : (
                            <span className="text-white">{card.description}</span>
                          )}
                        </p>
                        <div className="relative h-6 w-fit">
                          <img
                            src={card.logo.src}
                            alt={card.logo.alt}
                            width={card.logo.width}
                            height={card.logo.height}
                            className="h-full w-auto object-contain object-left"
                          />
                        </div>
                      </div>
                      <div
                        className="pointer-events-none absolute -inset-px rounded-[inherit] bg-[linear-gradient(67deg,rgba(13,14,18,.9)_0%,rgba(120,124,135,.9))] opacity-0 transition-opacity duration-300 group-hover:opacity-100 before:absolute before:inset-px before:rounded-[inherit] before:bg-[radial-gradient(75%_95%_at_84%_0%,rgba(25,26,32,.9),rgba(13,14,18,.8))]"
                        aria-hidden
                      />
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          {/* Contact Form */}
          <div className="relative z-10 w-full rounded-2xl bg-[#0d0e12] mx-auto overflow-hidden mb-8">
            <ContactForm />
          </div>
          
          {/* Radial Gradient Blur - Bottom */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -z-10 bottom-10 right-[20%] size-[464px] translate-x-[30%] translate-y-[35%] bg-[radial-gradient(50%_50%_at_50%_50%,rgba(140,150,170,.15)_20%,rgba(140,150,170,0))]"
          />
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default ContactMobile;